import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Btn, Container } from './ui';

export default function CTASection({ title, subtitle, primary, secondary }) {
  const { t } = useLanguage();
  return (
    <section className="px-5 py-16 sm:px-8 sm:py-20">
      <Container className="px-0">
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-brand-ink px-6 py-14 text-center sm:px-12 sm:py-16">
          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full bg-brand/30 blur-3xl" />
          <div className="pointer-events-none absolute -bottom-24 -right-24 h-72 w-72 rounded-full bg-brand/20 blur-3xl" />
          <div className="bp-grid-bg pointer-events-none absolute inset-0 opacity-40" />
          <div className="relative mx-auto max-w-2xl">
            <h2 className="font-display text-3xl font-bold leading-tight text-white sm:text-4xl">
              {title || t('home.cta.title')}
            </h2>
            <p className="mt-4 text-base leading-relaxed text-slate-300 sm:text-lg">
              {subtitle || t('home.cta.subtitle')}
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <Btn to="/demo" size="lg" variant="primary" arrow>{primary || t('home.cta.primary')}</Btn>
              <Btn to="/contact" size="lg" variant="outline" className="border-white/25 text-white hover:bg-white/10">
                {secondary || t('home.cta.secondary')}
              </Btn>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
}
